import SocialDevelopmentList from "./StatementIIISocialDevelopmentList";
import ChallengingBehaviors from "./StatementIIIChallengingBehaviors";
import PositiveBehaviors from "./StatementIIIPositiveBehaviors";
import PositiveSelf from "./StatementIIIPositiveSelf";
import ResourceIIIStatus from "./ResourceIIIStatus";
import { SummaryCompleteProps } from "../../app/models/SummaryComplete";
import { Grid } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import PrintSaveBtns from "../../app/common/PrintSaveBtn";
import { useState, useEffect, useCallback } from "react";
import agent from "../../app/api/agent";
import LoadingSpinner from "../../app/common/LoadingSpinner";
import { Answers } from "../../app/models/Answers";
import CongratsPopUp from "../../app/common/CongratsPopUp";
import BilingualPopUp from "../../app/common/BilingualPopUp";
import { PDF } from "../../app/models/Pdf";
import createAndOpenPDF from "../../app/utils/pdfutils";

export default function CompetencyIIIStatement() {
  const { user } = useAppSelector((state) => state.account);
  const [pdf, setPdf] = useState<PDF[]>([]);

  const [summaryCompleteProps, setSummaryCompleteProps] =
    useState<SummaryCompleteProps>({
      title: "My Competency III Statement",
      percent: "",
      header:
        "Competency III: To support social and emotional development and to provide positive guidance",
      description: `Write 1-2 sentences about how your teaching practices help to support social and emotional development and to provide positive guidance in each of the boxes provided. (Boxes will expand as needed.) For each text box, answer the question under the heading. Click on "See Ideas" to see some things you could write about using your own words.`,
    });

  const [answers, setAnswers] = useState<Answers[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userProgress, setUserProgress] = useState(0);

  const [bilingualModal, setBilingualModal] = useState(true);
  const handleBilingual = () => {
    setBilingualModal(false);
  };

  const [popUp, setPopUp] = useState(false);
  const handlePopUp = () => {
    setPopUp((prev) => !prev);
  };

  const fetchData = useCallback(async () => {
    try {
      if (user?.credentialName && user?.portfolioId) {
        const response = await agent.Answers.GetAnswers(
          user.credentialName,
          user.portfolioId,
          "CSIII"
        );
        const compData = await agent.Progress.GetCompentencyResultsByType(
          user.portfolioId,
          "CSIII"
        );
        const pdf = await agent.PDFViewer.GetPDFByType(
          user.credentialName,
          user.portfolioId,
          "CSIII"
        );

        setUserProgress(compData.statementProgress);
        setSummaryCompleteProps((prevSummaryCompleteProps) => ({
          ...prevSummaryCompleteProps,
          percent: compData.statementProgress + "%",
        }));

        setPdf(pdf);
        setAnswers(response);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }, [user?.credentialName, user?.portfolioId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleAnswerChange = (systemCodeId: number, newValue: string) => {
    setAnswers((prevAnswers) =>
      prevAnswers.map((answer) =>
        answer.systemCodeId === systemCodeId
          ? { ...answer, answer: newValue }
          : answer
      )
    );
  };

  const handleSaveDraft = async () => {
    setIsLoading(true);
    const filteredAnswers = answers.filter(
      (answer) => answer.id !== 0 || answer.answer !== ""
    );
    await agent.Answers.InsertorUpdateAnswers(filteredAnswers);
    fetchData();
    setIsLoading(false);
  };
  const handleSave = async () => {
    setIsLoading(true);
    const filteredAnswers = answers.filter(
      (answer) => answer.id !== 0 || answer.answer !== ""
    );
    await agent.Answers.InsertorUpdateAnswers(filteredAnswers);
    fetchData();
    setIsLoading(false);
    handlePopUp();
  };
  const handlePDF = async () => {
    createAndOpenPDF({
      pdfData: pdf,
      title: "My Competency Statement III",
      user: [
        user?.firstName,
        user?.lastName,
        user?.credentialName,
        user?.cdaCouncilCandidateId,
      ],
    });
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Grid container p={2} mb={2}>
        {user?.languageSpecialization && (
          <BilingualPopUp
            isPopUp={bilingualModal}
            btnColor={"comp3"}
            handlePopUp={handleBilingual}
          />
        )}
        <ResourceIIIStatus {...summaryCompleteProps} />
        <SocialDevelopmentList
          answersData={answers}
          onAnswerChange={handleAnswerChange}
        />
        <PositiveSelf
          answersData={answers}
          onAnswerChange={handleAnswerChange}
        />
        <PositiveBehaviors
          answersData={answers}
          onAnswerChange={handleAnswerChange}
        />
        <ChallengingBehaviors
          answersData={answers}
          onAnswerChange={handleAnswerChange}
        />
      </Grid>

      <PrintSaveBtns
        btnColor={"comp3"}
        onSave={handleSave}
        onDraft={handleSaveDraft}
        onPreview={handlePDF}
        Progress={userProgress}
        {...summaryCompleteProps}
      />
      <CongratsPopUp
        handlePopUp={handlePopUp}
        isPopUp={popUp}
        btnColor={"comp3"}
        background={"comp3.light"}
        description={
          "You have completed your Competency III Reflective Statement."
        }
      />
    </>
  );
}
